export default __webpack_public_path__ + "static/media/icon-trainin-center-tiny.d06f92b7.svg";